import { type ReactNode } from "react";
import { useHydrantenSync } from "./hydranten";
import { useInformationenSync } from "./informationen";
import { useKartenDetailObjekteSync } from "./kartendetailobjekte";
import { useKartenobjekteSync } from "./kartenobjekte";
import { useResourcesSync } from "./resources";
import { useSperrungenSync } from "./sperrungen";

/**
 * Configures all data providers, displaying a loading screen until all data is ready.
 */
export function DbProvider({ children }: { children: ReactNode }) {
  useHydrantenSync();
  useKartenobjekteSync();
  useKartenDetailObjekteSync();
  useInformationenSync();
  useSperrungenSync();
  useResourcesSync();

  return <>{children}</>;
}
